<template>
  <div
    class="card mb-25 border-0 rounded-0 bg-white error-404-card radius-7"
  >
    <div class="card-body letter-spacing style-terms-area legal-document">
      <h1>Termos de Uso</h1>

      <p class="document-date"><strong>Última atualização: 20 de julho de 2026.</strong></p>

      <p class="text-terms">
        Estes Termos de Uso regulam o acesso e a utilização da plataforma Centrallize,
        disponibilizada pela Sanvault para a gestão de salões de beleza, barbearias e
        outros estabelecimentos do setor de beleza e bem-estar. Ao criar uma conta,
        contratar um plano ou utilizar a plataforma, o cliente declara ter lido e
        aceitado estes Termos e a Política de Privacidade.
      </p>

      <h4>1. Quem pode utilizar a plataforma</h4>
      <p class="text-terms">
        O Centrallize destina-se ao uso profissional. A pessoa que cria ou administra
        uma conta declara ser maior de 18 anos, possuir capacidade legal e estar
        autorizada a representar o estabelecimento contratante. O cliente é
        responsável pelos usuários que convida e pelas atividades realizadas em sua
        conta.
      </p>

      <h4>2. Funcionalidades do Centrallize</h4>
      <p class="text-terms">
        Conforme o plano contratado e as integrações habilitadas, a plataforma pode
        oferecer cadastro de clientes e profissionais, agenda, serviços, produtos,
        estoque, vendas, pagamentos, comissões, metas, indicadores, gestão financeira,
        atendimento, notificações e integração com o WhatsApp Business. Novas funções
        podem ser incluídas, alteradas ou descontinuadas para evolução técnica,
        segurança ou adequação legal, preservados os direitos previstos em lei.
      </p>
      <p class="text-terms">
        O Centrallize fornece a ferramenta de gestão e não presta os serviços de beleza
        cadastrados no sistema, não participa da relação entre o estabelecimento e
        seus clientes e não responde pela qualidade, execução, preço ou resultado
        desses serviços.
      </p>

      <h4>3. Cadastro, acesso e segurança</h4>
      <ul class="text-terms">
        <li>fornecer informações verdadeiras, completas e atualizadas;</li>
        <li>manter senhas e credenciais em sigilo e utilizar acessos individuais;</li>
        <li>
          conceder a cada usuário apenas as permissões necessárias para sua função;
        </li>
        <li>
          comunicar imediatamente qualquer suspeita de acesso indevido ou incidente;
        </li>
        <li>
          manter atualizados os dados de contato utilizados para avisos de segurança,
          cobrança e recuperação da conta.
        </li>
      </ul>
      <p class="text-terms">
        O cliente responde pelas ações realizadas com suas credenciais, exceto quando
        comprovadamente decorrentes de falha imputável ao Centrallize.
      </p>

      <h4>4. Responsabilidades do cliente</h4>
      <p class="text-terms">O cliente é responsável por:</p>
      <ul class="text-terms">
        <li>
          utilizar a plataforma de acordo com a legislação, estes Termos e as
          instruções técnicas disponibilizadas;
        </li>
        <li>
          manter a exatidão dos cadastros, agendas, preços, estoque, dados financeiros
          e demais informações inseridas no sistema;
        </li>
        <li>
          obter bases legais, consentimentos e autorizações necessários para tratar
          dados de clientes, profissionais e terceiros;
        </li>
        <li>
          informar seus clientes sobre o uso de dados pessoais e atender aos direitos
          dos titulares previstos na LGPD;
        </li>
        <li>
          conferir agendamentos, mensagens, relatórios e lançamentos antes de tomar
          decisões operacionais ou financeiras;
        </li>
        <li>
          cumprir obrigações trabalhistas, tributárias, consumeristas, sanitárias e
          profissionais relacionadas à sua atividade.
        </li>
      </ul>

      <h4>5. Integração com o WhatsApp Business</h4>
      <p class="text-terms">
        A integração com o WhatsApp é opcional e depende da autorização do cliente,
        da disponibilidade dos serviços da Meta e da aprovação e manutenção de suas
        contas comerciais. WhatsApp e Meta são serviços de terceiros, regidos por
        termos, políticas, limites técnicos e preços próprios, que podem mudar sem
        controle do Centrallize.
      </p>
      <p class="text-terms">
        Ao ativar a integração, o cliente declara que possui autorização para usar o
        número e os ativos comerciais vinculados e compromete-se a:
      </p>
      <ul class="text-terms">
        <li>
          contatar apenas pessoas que forneceram o número e autorizaram as comunicações
          exigidas pela legislação e pelas políticas do WhatsApp;
        </li>
        <li>respeitar imediatamente pedidos de bloqueio ou cancelamento;</li>
        <li>
          utilizar modelos de mensagem aprovados quando exigidos e respeitar as
          janelas de atendimento definidas pelo WhatsApp;
        </li>
        <li>
          não enviar spam, conteúdo enganoso, ilícito, discriminatório ou proibido;
        </li>
        <li>
          disponibilizar atendimento humano ou outro canal de suporte quando utilizar
          automações.
        </li>
      </ul>
      <p class="text-terms">
        Bloqueios, rejeições de modelos, limitações, indisponibilidades ou cobranças
        impostas pela Meta não são controlados pelo Centrallize. O cliente é responsável
        por manter sua conta em conformidade e pagar eventuais tarifas cobradas pelo
        WhatsApp ou repassadas conforme o plano contratado.
      </p>

      <h4>6. Uso aceitável</h4>
      <p class="text-terms">É proibido:</p>
      <ul class="text-terms">
        <li>usar a plataforma para fins ilegais, fraudulentos ou abusivos;</li>
        <li>
          acessar dados de outras contas, contornar controles de segurança ou testar
          vulnerabilidades sem autorização expressa;
        </li>
        <li>
          copiar, modificar, descompilar, revender ou explorar a plataforma fora das
          permissões contratadas e da legislação aplicável;
        </li>
        <li>
          transmitir códigos maliciosos, sobrecarregar a infraestrutura ou prejudicar
          outros usuários;
        </li>
        <li>
          armazenar ou compartilhar conteúdo que viole direitos de terceiros, normas
          de privacidade ou propriedade intelectual;
        </li>
        <li>
          coletar números, comprar listas ou realizar disparos em massa sem base legal
          e autorização dos destinatários.
        </li>
      </ul>

      <h4>7. Planos, preços e pagamentos</h4>
      <p class="text-terms">
        Os recursos, limites, valores, periodicidade e condições de cada plano serão
        apresentados no momento da contratação. O cliente autoriza as cobranças
        recorrentes aplicáveis e deve manter um meio de pagamento válido. Tributos e
        tarifas de serviços de terceiros poderão ser cobrados ou repassados quando
        informados na oferta.
      </p>
      <p class="text-terms">
        Em caso de atraso ou falha de pagamento, o acesso poderá ser limitado ou
        suspenso após as comunicações cabíveis. Cancelamentos, reembolsos e direito de
        arrependimento observarão a oferta contratada e a legislação aplicável. O
        cancelamento impede novas renovações, mas não elimina valores já vencidos.
      </p>

      <h4>8. Disponibilidade, manutenção e suporte</h4>
      <p class="text-terms">
        Empregamos esforços razoáveis para manter a plataforma disponível e segura,
        mas não garantimos operação ininterrupta ou livre de falhas. Poderão ocorrer
        manutenções, atualizações, falhas de internet ou indisponibilidades de
        fornecedores. Sempre que possível, manutenções programadas com impacto
        relevante serão comunicadas previamente.
      </p>
      <p class="text-terms">
        O cliente deve manter procedimentos operacionais adequados para situações de
        indisponibilidade, especialmente para confirmar horários, pagamentos e
        atendimentos urgentes. O suporte será prestado pelos canais e horários
        informados na plataforma ou no plano contratado.
      </p>

      <h4>9. Dados, privacidade e confidencialidade</h4>
      <p class="text-terms">
        Cada parte deverá proteger informações confidenciais recebidas da outra. O
        tratamento de dados pessoais é regido pela Política de Privacidade e pela LGPD.
        Em regra, o cliente é o controlador dos dados que cadastra sobre seus clientes
        e profissionais, e o Centrallize os trata como operador para prestar o serviço.
        O Centrallize poderá atuar como controlador dos dados necessários à gestão da
        conta, cobrança, suporte, segurança e cumprimento de suas obrigações próprias.
      </p>

      <h4>10. Propriedade intelectual</h4>
      <p class="text-terms">
        O Centrallize e seus elementos, incluindo software, marcas, interfaces,
        documentação e conteúdos próprios, pertencem à Sanvault ou a seus
        licenciadores. A contratação concede ao cliente um direito limitado, não
        exclusivo, revogável e intransferível de utilizar a plataforma durante a
        vigência do plano. O cliente mantém os direitos sobre os dados e conteúdos que
        insere e concede apenas as autorizações necessárias para a prestação do
        serviço.
      </p>

      <h4>11. Suspensão e encerramento</h4>
      <p class="text-terms">
        A conta poderá ser suspensa ou encerrada em caso de violação destes Termos,
        risco à segurança, uso ilegal, abuso, inadimplência ou exigência de autoridade
        competente. Quando a situação permitir, o cliente será informado e terá
        oportunidade razoável para corrigir a irregularidade.
      </p>
      <p class="text-terms">
        Após o cancelamento, o acesso às funcionalidades poderá ser encerrado. O
        cliente deve exportar os dados necessários antes do término do serviço. Os
        dados serão retidos, eliminados ou anonimizados conforme a Política de
        Privacidade, as obrigações legais e os prazos técnicos de cópias de segurança.
      </p>

      <h4>12. Responsabilidade e garantias</h4>
      <p class="text-terms">
        O Centrallize responderá por danos diretos comprovadamente causados por falha
        que lhe seja imputável, nos limites permitidos pela legislação. Não responde
        por informações incorretas inseridas pelo cliente, decisões tomadas com base
        em dados não conferidos, conduta de profissionais ou consumidores, falhas de
        terceiros, uso indevido de credenciais ou descumprimento das políticas do
        WhatsApp pelo cliente.
      </p>
      <p class="text-terms">
        Nenhuma disposição destes Termos exclui garantias ou responsabilidades que não
        possam ser afastadas por lei, inclusive direitos assegurados pela legislação
        de proteção de dados e de defesa do consumidor quando aplicável.
      </p>

      <h4>13. Alterações destes Termos</h4>
      <p class="text-terms">
        Estes Termos poderão ser atualizados para refletir mudanças legais, técnicas,
        comerciais ou operacionais. A versão vigente será publicada nesta página com
        a data de atualização. Alterações relevantes serão comunicadas com antecedência
        razoável quando exigido, e o uso continuado após sua vigência representará
        aceitação, sem prejuízo dos direitos previstos em lei.
      </p>

      <h4>14. Legislação e foro</h4>
      <p class="text-terms">
        Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica
        eleito o foro competente do domicílio da empresa responsável pelo Centrallize,
        ressalvado o direito do consumidor de optar pelo foro de seu domicílio e outras
        regras obrigatórias de competência.
      </p>

      <h4>15. Contato</h4>
      <p class="text-terms">
        Para dúvidas sobre estes Termos, entre em contato pelo e-mail
        <a href="mailto:contato@sanvault.com.br">contato@sanvault.com.br</a>.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
};
</script>

<style scoped>
.legal-document {
  max-width: 980px;
  margin: 0 auto;
  text-align: left;
}

.legal-document h1 {
  width: 100%;
  margin-bottom: 8px;
  text-align: center;
}

.legal-document h4 {
  margin-top: 28px;
}

.document-date {
  width: 100%;
  margin-bottom: 24px;
  text-align: center;
}

.text-terms {
  margin-bottom: 16px !important;
  line-height: 1.7;
}

.text-terms li + li {
  margin-top: 8px;
}
</style>
